module.exports = __webpack_public_path__ + "img/96.5.COD.c4659320.png";